<div class="container-fluid my-4">
    <div class="row custom-row-height">
        <div class="col-md-8">
            <div class="image-container main-image-container gallery-container"
                #mainImageContainer
                (touchstart)="onTouchStart($event)"
                (touchmove)="onTouchMove($event)"
                (touchend)="onTouchEnd($event)"
                (mouseenter)="onMouseEnter()"
                (mouseleave)="onMouseLeave($event)"

                (mousedown)="onMouseDown($event)"
                (mousemove)="onMouseMove($event)"
                (mouseup)="onMouseUp($event)"
            >
            @if (mainImageContainer && isDragging) {
                <div class="overlay-drag-capture"></div>
            }
                @for (slide of slides; track slide.imageUrl; let i = $index) {
                    @if (i === 0 || loadSecondarySlides) {
                        <img
                            #currentGalleryImage
                            [class.active-gallery-image]="i === currentIndex"
                            [src]="slide.imageUrl"
                            [attr.srcset]="buildSrcset(slide)"
                            [attr.sizes]="slideSizes"
                            [attr.width]="slide.width"
                            [attr.height]="slide.height"
                            class="img-fluid gallery-image"
                            [attr.fetchpriority]="i === 0 ? 'high' : null"
                            [attr.loading]="i === 0 ? 'eager' : 'lazy'"
                            alt="Gallery Image {{i + 1}}"
                            (load)="initializeLayoutAndSlide()">
                    }
                }

                <button class="gallery-nav gallery-prev"
                        type="button"
                        aria-label="Slide precedente"
                        (mousedown)="$event.stopPropagation()"
                        (mousemove)="$event.stopPropagation()"
                        (mouseup)="$event.stopPropagation()"
                        (click)="prevImage($event)"
                        [disabled]="slides.length <= 1"
                >
                    &lt;
                </button>
                <button class="gallery-nav gallery-next"
                        type="button"
                        aria-label="Slide successiva"
                        (mousedown)="$event.stopPropagation()"
                        (mousemove)="$event.stopPropagation()"
                        (mouseup)="$event.stopPropagation()"
                        (click)="nextImage($event)"
                        [disabled]="slides.length <= 1"
                >
                    &gt;
                </button>

                <div class="slide-overlay" [class.active-overlay]="showOverlay">
                    <div class="overlay-content" [innerHTML]="processedHtmlContent" (click)="handleOverlayClick($event)"></div>
                </div>

            </div>
        </div>

        <div class="col-md-4 d-flex flex-column">
            <!-- Banner 2 e 3: propri della slide corrente o standard. Stessa struttura <a><img> in ogni caso
                 (senza link l'<a> non ha href): l'<img> non viene mai ricreato, cosi' resta lo stile
                 impostato da adjustColumnHeights() su mobile. -->
            @let banner2 = sideImage(0);
            @let banner3 = sideImage(1);
            <div class="row flex-grow-1 mb-2">
                <div class="col-12 h-100">
                    <div class="image-container secondary-image-container">
                        <a [attr.href]="banner2.link" (click)="handleOverlayClick($event)">
                            <img [src]="banner2.src" class="img-fluid" alt="Immagine Secondaria 1">
                        </a>
                    </div>
                </div>
            </div>
            <div class="row flex-grow-1 mt-2">
                <div class="col-12 h-100">
                    <div class="image-container secondary-image-container">
                        <a [attr.href]="banner3.link" (click)="handleOverlayClick($event)">
                            <img [src]="banner3.src" class="img-fluid" alt="Immagine Secondaria 2">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>